import React, { memo, useRef, useEffect } from "react";
import classes from "./DRadioInputs.module.css";

const DRadioInput = ({
  id,
  name,
  label,
  value,
  checked,
  onChange,
  customClass,
  allowUncheck = false, // ✅ new optional prop (default = false)
}) => {
  const inputRef = useRef(null);
  const wasCheckedRef = useRef(checked);
  const isUncheckingRef = useRef(false);

  // Update ref when checked state changes
  useEffect(() => {
    wasCheckedRef.current = checked;
  }, [checked]);

  const handleMouseDown = (event) => {
    // ✅ Only handle uncheck if feature is explicitly enabled and already checked
    if (allowUncheck && wasCheckedRef.current) {
      isUncheckingRef.current = true;
      event.preventDefault(); // prevent default behavior (like radio check)
      event.stopPropagation(); // stop event bubbling
      
      // Send deselection with the actual value (checked = false)
      onChange(false, value); 
    } else {
      isUncheckingRef.current = false;
    }
  };

  const handleRadioChange = (event) => {
    // If we're unchecking via mouse down, the change event might still fire,
    // but we've already handled the deselection.
    if (isUncheckingRef.current) {
      isUncheckingRef.current = false;
      return; // Don't process the change event
    }

    // Normal change handling (selection)
    onChange(event.target.checked, event.target.value);
  };

  return (
    <div className={`${classes.cus_radio} ${customClass}`}>
      <input
        ref={inputRef}
        type="radio"
        id={id}
        value={value}
        name={name}
        checked={checked}
        onMouseDown={handleMouseDown}
        onChange={handleRadioChange}
      />
      {/*
        Using the same onMouseDown on the label ensures the unchecking logic 
        works when clicking the label as well.
      */}
      <label htmlFor={id} onMouseDown={handleMouseDown}>
        {label}
      </label>
    </div>
  );
};

export default memo(DRadioInput);